import React, { useState, useEffect } from "react";
import axios from 'axios';
import ReactDOM from "react-dom";
import { useLocalStorage } from 'react-use';
import { BrowserRouter, Route, Switch, Redirect, useHistory } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";

import ManagerLayout from "layouts/Manager.js";
import AdminLayout from "layouts/Admin.js";
import AuditorLayout from "layouts/Auditor.js";
import AuditeeLayout from "layouts/Auditee.js";

function ProtectedRoute({path, guard, component}) {

  const [auth] = useLocalStorage('authenticated');

  switch (true) {
    case Array.isArray(guard) &&
      !auth.roles?.find(role => guard.includes(role.ROLE_CODE)):
    case typeof guard === 'string' && auth?.roles?.includes(guard):
      return <Redirect to="/auth/403" />;
    case !auth:
      return <Redirect to="/" />;
    default:
      return <Route path={path} component={component} />;
  }
}


function HomeComponent ({ auth }) {

  const [redirecting, setRedirecting] = useState(true);
  const history = useHistory();

  const authSwitcher = () => {

    setRedirecting(true);

    const role = auth?.roles?.[0]?.ROLE_CODE;
    console.log(role, auth);
    switch (role) {
      case 'admin':
        setRedirecting(false);
        return history.push(`/admin/dashboard`);
      case 'manager':
        setRedirecting(false);
        return history.push(`/manager/dashboard`);
      case 'auditor':
        setRedirecting(false);
        return history.push(`/auditor/${auth.employee.EMP_ID}/dashboard`);
      case 'auditee':
        setRedirecting(false);
        return history.push(`/auditee/${auth.employee.EMP_ID}/dashboard`);
      default:
        return window.location.href = `https://bpmi.umn.ac.id/siami/default/unauthorized`;

    }
  }

  useEffect(authSwitcher, []);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    //const isSafari = /^((?!chrome|chromium|android|edg).)*safari/i.test(userAgent);
    const isSafari = /^((?!chrome|chromium|android|crios|fxios|edg).)*safari/i.test(userAgent);
    if (isSafari) {
      alert("For better experience please use chrome instead of safari!!");
      const token = JSON.parse(localStorage.getItem('authenticated'))?.token;
      localStorage.removeItem('authenticated');
      window.location.href = `${process.env.REACT_APP_API_HOST}auth/logout?access_token=${token}`;
    }
  }, []);

  if (redirecting) {
    return <span>Loading....</span>;
  }

  return <span>Redirecting...</span>

}

function App() {


  const token = new URLSearchParams(window.location.search).get("access_token");
  const [auth, setAuth] = useLocalStorage('authenticated');
  const [authenticating, setAuthenticating] = useState(true);

  const handleIfAuthenticated = async () => {

    setAuthenticating(true);

    try {

      if (!token) return window.location.href = `${process.env.REACT_APP_API_HOST}auth/login`;

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}auth/identify`,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      console.log('identified', response.data);

      setAuth(response.data);

      return setAuthenticating(false);

    } catch (error) {

      const { response } = error;

      console.log('res status index: ', response?.status, error)

      switch (response?.status) {
        case 403: return setDisplay(<Redirect to="/auth/403" />);
        case 401:
          return window.location.href = `${process.env.REACT_APP_API_HOST}auth/login`;
      }
    }
  }


  useEffect(handleIfAuthenticated, []);

  if (authenticating) return <>Authenticating...</>;

  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoute
          path="/admin"
          guard={'admin'}
          component={AdminLayout}
        />
        <ProtectedRoute
          path="/manager"
          guard={'manager'}
          component={ManagerLayout}
        />
        <ProtectedRoute
          path={`/auditor/:employeeId`}
          guard={`auditor`}
          component={AuditorLayout}
        />
        <ProtectedRoute
          path={`/auditee/:employeeId`}
          guard={`auditee`}
          component={AuditeeLayout}
        />
        <Route path="/">
          <HomeComponent auth={auth} />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

ReactDOM.render(<App />, document.getElementById("root"));
